var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0001 10.2C9.15401 10.2 10.9001 8.45394 10.9001 6.30002C10.9001 4.14611 9.15401 2.40002 7.0001 2.40002C4.84619 2.40002 3.1001 4.14611 3.1001 6.30002C3.1001 8.45394 4.84619 10.2 7.0001 10.2ZM7.6501 11.1573C10.049 10.8393 11.9001 8.78585 11.9001 6.30002C11.9001 3.59383 9.70629 1.40002 7.0001 1.40002C4.2939 1.40002 2.1001 3.59383 2.1001 6.30002C2.1001 8.88854 4.10725 11.0083 6.6501 11.1877V12.6H7.6501V11.1573ZM7.0001 7.40002C7.60761 7.40002 8.1001 6.90754 8.1001 6.30002C8.1001 5.69251 7.60761 5.20002 7.0001 5.20002C6.39258 5.20002 5.9001 5.69251 5.9001 6.30002C5.9001 6.90754 6.39258 7.40002 7.0001 7.40002ZM7.0001 8.40002C8.1599 8.40002 9.1001 7.45982 9.1001 6.30002C9.1001 5.14023 8.1599 4.20002 7.0001 4.20002C5.8403 4.20002 4.9001 5.14023 4.9001 6.30002C4.9001 7.45982 5.8403 8.40002 7.0001 8.40002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopCircle);
export default __webpack_public_path__ + "static/media/icon-stop-circle.e57d177cb65aa0fc13925e8650a7e7a8.svg";
export { ForwardRef as ReactComponent };